import { ePostType, ReportableItem } from "../../../@types/Posts";
import { AnalysisResult, News } from "../../../@types/Analysis";
import { ReportableBase } from "../base/ReportableBase";
import { decodePairId } from "../../../utils";
import { generatePostContent } from "../../../helpers/News";
import { getHighlightPostFromImpression } from "../../../helpers/Highlights";
import { isArray, uniqBy } from "lodash";
import usePost from "../../../hooks/usePost";

export class ReportPostsService extends ReportableBase<ReportableItem[]> {
  constructor(
    private readonly analysisResult: AnalysisResult,
    private readonly news: News[],
    private readonly encodedPairId: string
  ) {
    const lastSaveKeyName = "posts_last_save_details";
    const lastReportedJsonKey = "posts_last_report_json";
    super(lastSaveKeyName, lastReportedJsonKey, encodedPairId);
  }

  public async report(data: ReportableItem[]): Promise<boolean> {
    const isAlreadyReported = this.isAlreadyReported(data);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { storeReport } = usePost();

    if (!isAlreadyReported) {
      const storeData = await storeReport(data);

      if (storeData) {
        this.updateLastReportedJSON(data);
        this.updateLastSave();

        return true;
      }
    }

    return false;
  }

  public getReportableData(): ReportableItem[] {
    const news = this.getNewsPosts();
    const highlights = this.getHighlightsPosts();

    return [...news, ...highlights];
  }

  private getNewsPosts(): ReportableItem[] {
    const decodedPairId = decodePairId(this.encodedPairId);
    const generatedPosts: ReportableItem[] = [];

    if (isArray(this.news)) {
      this.news.forEach((singleNews) => {
        const content = generatePostContent(singleNews);

        if (content) {
          generatedPosts.push({
            newsId: parseInt(String(singleNews.newsId), 10),
            asset_id: decodedPairId,
            content,
            image: singleNews.image,
            type: ePostType.news,
            url: singleNews.linkExternal,
          });
        }
      });
    }

    return generatedPosts;
  }

  private getHighlightsPosts(): ReportableItem[] {
    const decodedPairId = decodePairId(this.encodedPairId);
    const impressions = this.analysisResult.impressions;
    const generatedHighlightsPosts: ReportableItem[] = [];

    impressions.forEach((impression: any) => {
      const highlight = getHighlightPostFromImpression(impression);

      if (highlight) {
        generatedHighlightsPosts.push({
          newsId: null,
          asset_id: decodedPairId,
          content: highlight.content,
          image: highlight.image,
          type: ePostType.highlight,
          url: "",
        });
      }
    });

    return generatedHighlightsPosts;
  }
}
